<ng-template #dropDownContent>
  <div class="drop-down-anchor" [class.overlayed]="useOverlay" (click)="$event.stopPropagation()">
    <div class="flow-drop-down" [class.open]="open" [class.scrollable]="scrollable" [class.no-footer]="!footer" [style.width.px]="width" [style.max-height.px]="open ? height : 0" (transitionend)="onTransitionEnd($event)">
      @if (searchbarLabel) {
        <div class="drop-down-header">
          <flow-search-input [placeholder]="searchbarLabel" [value]="searchTerm" [searchButtonShown]="false" (valueChange)="onSearchInputChange($event)"></flow-search-input>
        </div>
      }
      <div class="drop-down-list">
        @for (row of rows; track $index) {
          @if (row.kind === "divider") {
            <div class="drop-down-divider" [class.line-only]="!row.divider.title" [class.first-row]="$first">
              @if (row.divider.title) {
                <p agText="caption-1-medium" class="drop-down-divider__title">{{ row.divider.title }}</p>
              }
            </div>
          } @else if (row.item.custom) {
            <div class="drop-down-custom-item" (click)="onItemSelected(row.item)">
              @if (row.item.checkbox !== "none") {
                <flow-checkbox-v2 [radio]="row.item.checkbox === 'radio'" [checked]="row.item.selected"></flow-checkbox-v2>
              }
              <p agText="body-3" class="drop-down-custom-item__title">{{ row.item.title }}</p>
              <button type="button" class="drop-down-custom-item__delete" aria-label="Delete" (click)="deleteCustomItem(row.item)">
                <img [src]="iconService.Icon.trash_can_red" aria-hidden="true" />
              </button>
            </div>
          } @else {
            <flow-drop-down-item [item]="row.item" [type]="type" [isSelected]="row.item.selected" [highlightSelected]="deferSelection" (selected)="onItemSelected(row.item)"></flow-drop-down-item>
          }
        }
        @if (!hasVisibleRows) {
          <div class="drop-down-empty">
            @if (searchTerm) {
              <p agText="body-2-medium">{{ noResultsTitle }}</p>
              <p agText="body-3" class="drop-down-empty__subtitle">{{ noResultsSubtitle }}</p>
            } @else {
              <p agText="body-2-medium">{{ emptyTitle }}</p>
              @if (emptySubtitle) {
                <p agText="body-3" class="drop-down-empty__subtitle">{{ emptySubtitle }}</p>
              }
            }
          </div>
        }
      </div>
      @if (addable && addRowOpen) {
        <div class="drop-down-add">
          <flow-text-input class="drop-down-add__input" [placeholder]="addPlaceholder" [value]="addValue" [hideClear]="true" (valueChange)="onAddValueChange($event)" (keydown.enter)="addCustomItem()"></flow-text-input>
          <flow-button-v2 label="Add" type="secondary" size="medium" [disabled]="!canAddCustomItem" (click)="addCustomItem()"></flow-button-v2>
          <flow-button-v2 [icon]="iconService.Icon.cross" ariaLabel="Close" type="secondary" size="medium" (click)="closeAddRow()"></flow-button-v2>
        </div>
      }
      @if (footer || addable) {
        <div class="drop-down-footer">
          @if (addable && !addRowOpen) {
            <button type="button" class="drop-down-footer__add" (click)="showAddRow()">
              <img class="drop-down-footer__add-icon" [src]="iconService.Icon.plus" alt="" aria-hidden="true" />
              <span agText="body-3">{{ addTriggerLabel }}</span>
            </button>
          }
          @if (footer?.tertiaryText) {
            <flow-button-v2 [label]="footer.tertiaryText" size="small" [ghostVersion]="true" (click)="footerClick('tertiary')"></flow-button-v2>
          }
          @if (footer?.secondaryText || footer?.primaryText) {
            <div class="flex-row" [style.gap.px]="8" [style.margin-left]="'auto'">
              @if (footer.secondaryText) {
                <flow-button-v2 [label]="footer.secondaryText" type="secondary" size="small" (click)="footerClick('secondary')"></flow-button-v2>
              }
              @if (footer.primaryText) {
                <flow-button-v2 [label]="footer.primaryText" type="primary" size="small" (click)="footerClick('primary')"></flow-button-v2>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

@if (!useOverlay) {
  <ng-container [ngTemplateOutlet]="dropDownContent"></ng-container>
}
